import React from 'react';
import { Button } from '../../../../../UiKit';

export const InitialMapView = React.memo(({ refreshMap }) => {
  return (
    <div className='expiredState '>
      <div className='bgImg'></div>
      <div className='tw-flex tw-h-full tw-items-center tw-justify-center tw-w-full tw-p-4 tw-leading-snug'>
        <p className='heading dark '>Go To Map</p>
        <p className='tw-text-300 tw-leading-normal'>
          Please load the map to see the delivery partner’s current location
        </p>
        <div
          className='tw-h-1 tw-px-5 tw-py-5 tw-border-solid tw-border-green-700  tw-border-[1px] tw-rounded-lg tw-flex tw-items-center tw-justify-center tw-text-200 tw-text-green-700 tw-cursor-pointer tw-mt-2'
          onClick={refreshMap}
        >
          Load Map
        </div>
      </div>
    </div>
  );
});
